import React, { Fragment } from 'react';
import i18n from "../../../i18next";
import { Container, Row, Col, Label, Input, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { AvForm, AvField, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';

import DeliverySVG from "../../common/svgs/DeliverySVG"
import PickUpSVG from "../../common/svgs/PickUpSVG";
import CurbsideSVG from "../../common/svgs/CurbsideSVG";
import InStoreSvg from "../../common/svgs/InStoreSVG";
import { getCurrencySymbol } from '../../../utils/CommonUtils';

import SectionTitle from '../customerInsightScreen/SectionTitle';
import FilterSelectionScreen from './FilterSelectionScreen';
import LabeledToggleElement from './LabeledToggleElement';
import SearchButton from '../customerInsightScreen/SearchButton';
import CustomInsightsModal from '../customerInsightScreen/CustomInsightsModal';
import { loadRestaurantProducts, loadPromotionNames, loadInitialAudienceCount, saveMarketingAutomation, editMarketingAutomation, setSelectedMarketingAutomation, deletePromotion, loadCustomerAutomationSearch } from '../../../actions/index'
import EmailSVG from '../../common/svgs/EmailSVG';
import PhoneSVG from '../../common/svgs/PhoneSVG';
import ConfirmationScreen from '../settings/pos/ConfirmationScreen';
import InformationTooltip from './InformationTooltip';
import EmailTemplateContainer from './EmailTemplateContainer';
import CustomerSearch from './CustomerSearch';
import CommonModal from '../../common/CommonModal';
import UsedPromoCodesModal from './UsedPromoCodesModal';

class MarketingAutomationScreen extends React.Component {

    state = {
        editMode: false,
        active: true,
        name: '',
        description: '',
        notificationType: 'EMAIL',
        notificationFrequency: 'ONCE_FUTURE',
        orderTypeDelivery: true,
        orderTypeCollection: true,
        orderTypeCurbside: true,
        orderTypeInStore: true,
        initialNotificationDays: null,
        repeatNotificationDays: null,
        coolDownPeriod: 30,
        promoCodeValidity: 30,
        day1: null, //Sunday
        day2: 12, //Monday
        day3: 12, //Tuesday
        day4: 12, //Wendesday
        day5: 12, //Thursday
        day6: 12, //Friday
        day7: 12, //Saturday
        discountType: 'PRICE_DISCOUNT',
        priceDiscount: {
            discountAmount: null,
            discountInPercentage: false
        },
        freeProduct: {
            productId: null,
            productName: '',
            quantity: null
        },
        comboDeal: {
            buyProductsCount: null,
            freeProductsCount: null,
            discountValue: null,
            valueIsDiscount: true,
            valueInPercentage: false
        },
        products: null,
        currentPageNumber: 0,
        matchedFromSearch: [],
        promotions: null,

        filters: {
            minOrderCount: null,
            maxOrderCount: null,

            minAverageOrderValue: null,
            maxAverageOrderValue: null,

            minLifetimeOrderValue: null,
            maxLifetimeOrderValue: null,

            minOrderFrequency: null,
            maxOrderFrequency: null,

            firstOrderStartDate: null,
            firstOrderEndDate: null,

            lastOrderStartDate: null,
            lastOrderEndDate: null,

            minHourOfDay: null,
            maxHourOfDay: null,

            minDayOfWeek: null,
            maxDayOfWeek: null,

            customerStatus: null,
            vip: null,

            productPosId: null,
            promotionId: null,

            redeemed: null,

            lastContactStartRange: null,
            lastContactEndRange: null,

            orderTypeCollection: [],
            paymentTypeCollection: [],
            sourceTypeCollection: []
        },
        isFilterModalOpen: false,
        isCustomerListModalOpen: false,
        isAddCustomerListModalOpen: false,
        deletePromotionConfirmationOpened: false,
        emailTemplate: null,
        isHelperModalOpen: false,
        isUsedPromoCodesModalOpen: false,
        customerId: null
    }

    componentDidMount = () => {

        const { id } = this.props.match.params;
        const brandId = this.props.restaurant ? this.props.restaurant.chain.id : null;

        //If the page gets reloaded once it is in the /marketing-automation (create/edit page)
        //we redirect it to /marketing-automations because the selectedMarketingAutomation data gets lost while redirecting
        if (!this.props.selectedMarketingAutomation.redirected){ 
            this.props.history.push(`/restaurant/${id}/marketing-automations`);
        }
        
        this.props.loadRestaurantProducts(id, true, () => { this.setState({ ...this.state, products: this.props.products }) });
        this.props.loadPromotionNames(id, () => { this.setState({ ...this.state, promotions: this.props.promotions }) });

        //if selectedMarketingAutomation is null -> open create Trigger 
        //else -> open edit Trigger and fill state with the trigger's data
        if (this.props.selectedMarketingAutomation.trigger !== null) {
            const trigger = this.props.selectedMarketingAutomation.trigger;
            let productName = '';

            this.props.loadCustomerAutomationSearch(trigger.id, this.state.currentPageNumber, brandId);

            if (trigger.freeProduct !== null && this.props.products !== null) {
                const productsArr = this.props.products.filter(obj => { return obj.id === trigger.freeProduct.productId })
                if (productsArr.length > 0) {
                    productName = productsArr[0].name;
                }

            }
            const priceDiscount = trigger.priceDiscount !== null ? { discountAmount: trigger.priceDiscount.discountValue, discountInPercentage: trigger.priceDiscount.valueInPercentage } : null;
            const freeProduct = trigger.freeProduct !== null ? { productId: trigger.freeProduct.productId, productName: productName, quantity: trigger.freeProduct.quantity } : null;
            const comboDeal = trigger.comboDeal !== null ? { buyProductsCount: trigger.comboDeal.buyProductsCount, freeProductsCount: trigger.comboDeal.freeProductsCount, discountValue: trigger.comboDeal.discountValue, valueIsDiscount: trigger.comboDeal.valueIsDiscount, valueInPercentage: trigger.comboDeal.valueInPercentage } : null;

            let orderTypeDelivery, orderTypeCollection, orderTypeCurbside, orderTypeInStore = false;

            trigger.orderTypes.forEach(element => {
                if (element.id === 1) {
                    orderTypeDelivery = true;
                } else if (element.id === 2) {
                    orderTypeCollection = true;
                } else if (element.id === 4) {
                    orderTypeCurbside = true;
                } else if (element.id === 5) {
                    orderTypeInStore = true;
                }
            });

            let day1, day2, day3, day4, day5, day6, day7 = null;

            trigger.notificationTimes.forEach(element => {
                if (element.dayIndex === 1) {
                    day1 = element.hour;
                } else if (element.dayIndex === 2) {
                    day2 = element.hour;
                } else if (element.dayIndex === 3) {
                    day3 = element.hour;
                } else if (element.dayIndex === 4) {
                    day4 = element.hour;
                } else if (element.dayIndex === 5) {
                    day5 = element.hour;
                } else if (element.dayIndex === 6) {
                    day6 = element.hour;
                } else if (element.dayIndex === 7) {
                    day7 = element.hour;
                }
            });

            this.setState({
                editMode: true,
                active: trigger.activeMarketingAutomation,
                name: trigger.name,
                description: trigger.description,
                notificationType: trigger.notificationMethod,
                discountType: trigger.discountType,
                priceDiscount,
                freeProduct,
                comboDeal,
                notificationFrequency: trigger.notificationFrequency.notificationMethodType,
                initialNotificationDays: trigger.notificationFrequency.initialPeriod,
                repeatNotificationDays: trigger.notificationFrequency.repeatPeriod,
                coolDownPeriod: trigger.coolDownPeriod,
                promoCodeValidity: trigger.promoCodeValidity,
                orderTypeDelivery,
                orderTypeCollection,
                orderTypeCurbside,
                orderTypeInStore,
                day1,
                day2,
                day3,
                day4,
                day5,
                day6,
                day7,

                filters: trigger.filters
                //todo TEMPLATE
            })
        }
    }

    componentDidUpdate(prevProps) {
        if(this.props.products !== prevProps.products && this.props.selectedMarketingAutomation.trigger !== null) {
            const trigger = this.props.selectedMarketingAutomation.trigger;
            let productName = '';

            if (trigger.freeProduct !== null && this.props.products !== null && this.props.products.length > 0) {
                const productsArr = this.props.products.filter(obj => { 
                    return obj.id === trigger.freeProduct.productId 
                })
                if (productsArr.length > 0) {
                    productName = productsArr[0].name;
                }

                const freeProduct = { 
                    productId: trigger.freeProduct.productId, 
                    productName: productName, 
                    quantity: trigger.freeProduct.quantity 
                };

                this.setState({
                    freeProduct: freeProduct
                })
            }
        }
    }

    toggleFilterModal = () => {
        this.setState({ isFilterModalOpen: !this.state.isFilterModalOpen })
    }


    toggleCusotmerListModal = () => {
        this.setState({ isCustomerListModalOpen: !this.state.isCustomerListModalOpen })
        if(this.state.isAddCustomerListModalOpen) {
            this.setState({ isAddCustomerListModalOpen: !this.state.isAddCustomerListModalOpen })
        }
    }

    toggleAddCustomerListModalOpen = () => {
        this.setState({ isAddCustomerListModalOpen: !this.state.isAddCustomerListModalOpen })
    }

    toggleConfirmationScreen = () => {
        this.setState({ ...this.state, deletePromotionConfirmationOpened: !this.state.deletePromotionConfirmationOpened });
    }

    toggleHelperModal = () => {
        this.setState({ ...this.state, isHelperModalOpen: !this.state.isHelperModalOpen });
    }

    toggleUsedPromoCodesModal = (customerId) => {
        this.setState({
            customerId: customerId ? customerId : this.state.customerId,
            isCustomerListModalOpen: !this.state.isCustomerListModalOpen,
            isUsedPromoCodesModalOpen: !this.state.isUsedPromoCodesModalOpen,
        })
    }

    applySelectedFilters = filters => {
        this.setState({ filters: filters, isFilterModalOpen: !this.state.isFilterModalOpen })
    }

    changeState = ({ target }) => {
        const value = target.value === '' ? null : target.value
        this.setState({ ...this.state, [target.name]: value });
    }

    changeActiveFlag = e => {
        this.setState({ active: e.target.checked });
    }

    changeNotificationTypeEmail = (e) => {
        this.setState({ notificationType: e.target.checked ? 'EMAIL' : 'SMS' });
    };

    changeNotificationTypeSms = (e) => {
        this.setState({ notificationType: e.target.checked ? 'SMS' : 'EMAIL' });
    };

    changeNotificationFrequencyOnce = e => {
        this.setState({ 
            notificationFrequency: e.target.checked ? 'ONCE_FUTURE' : 'REPEAT_FUTURE',
            repeatNotificationDays: null,
            initialNotificationDays: null 
        });
    }

    changeNotificationFrequencyRepeated = e => {
        this.setState({ 
            notificationFrequency: e.target.checked ? 'REPEAT_FUTURE' : 'ONCE_FUTURE',
            repeatNotificationDays: null,
            initialNotificationDays: null  
        });
    }

    changeOrderTypeDelivery = e => {
        this.setState({ orderTypeDelivery: e.target.checked });
    }

    changeOrderTypeCollection = e => {
        this.setState({ orderTypeCollection: e.target.checked });
    }

    changeOrderTypeCurbside = e => {
        this.setState({ orderTypeCurbside: e.target.checked });
    }

    changeOrderTypeInStore = e => {
        this.setState({ orderTypeInStore: e.target.checked });
    }

    changeDiscountTypePriceDiscount = e => {
        if (e.target.checked && this.state.discountType !== 'PRICE_DISCOUNT') {
            this.setState({ discountType: 'PRICE_DISCOUNT' });
        }
    }

    changeDiscountTypeFreeProduct = e => {
        if (e.target.checked && this.state.discountType !== 'FREE_PRODUCT') {
            this.setState({ discountType: 'FREE_PRODUCT' });
        }
    }

    changeDiscountTypeComboDeal = e => {
        if (e.target.checked && this.state.discountType !== 'COMBO_DEAL') {
            this.setState({ discountType: 'COMBO_DEAL' });
        }
    }

    changePriceDiscountAmount = e => {
        this.setState({ priceDiscount: { discountAmount: e.target.value, discountInPercentage: this.state.priceDiscount.discountInPercentage } })
    }

    changePriceDiscountInPercentage = e => {
        this.setState({ priceDiscount: { discountAmount: this.state.priceDiscount.discountAmount, discountInPercentage: e.target.checked } })
    }

    changeFreeproductQuantity = e => {
        this.setState({ freeProduct: { ...this.state.freeProduct, quantity: e.target.value } })
    }

    changeFreeProductName = e => {
        this.setState({ freeProduct: { ...this.state.freeProduct, productName: e.target.value } })
    }

    changeComboDealInputs = e => {
        this.setState({ comboDeal: { ...this.state.comboDeal, [e.target.name]: e.target.value } })
    }

    changeComboDealValueInPercent = e => {
        this.setState({ comboDeal: { ...this.state.comboDeal, valueInPercentage: e.target.checked } })
    }

    changeComboDealValueDiscount = e => {
        this.setState({ comboDeal: { ...this.state.comboDeal, valueIsDiscount: e.target.checked } })
    }

    getValue(value) {

        if (value === 0) {
            return 0;
        }

        return value || '';
    }

    comboDealDiscountValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;
        // No negative values, no dots, no commas.
        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
            || inputKeyCode == 101 || inputKeyCode == 46 || inputKeyCode == 44)
             e.preventDefault();
        }
    }

    loadInitialCustomerCount = () => {
        const restaurantId = this.props.match.params.id;
        this.props.loadInitialAudienceCount(restaurantId, this.state.filters);
    }

    onBack = () => {
        const restaurantId = this.props.match.params.id;

        this.props.setSelectedMarketingAutomation(null, () => {
            this.props.history.push(`/restaurant/${restaurantId}/marketing-automations`);

        });
    }

    saveTrigger = () => {
        const restaurantId = this.props.match.params.id;

        if (this.props.selectedMarketingAutomation.trigger === null) {

            //1. Create promotion; 
            //2. Clear selectedMarketingAutomation reducer; 
            //3. Redirect to list screen
            this.props.saveMarketingAutomation(restaurantId, this.state, () => {
                this.props.setSelectedMarketingAutomation(null, () => {
                    this.props.history.push(`/restaurant/${restaurantId}/marketing-automations`);

                });
            });
            return;
        }

        //1. Update promotion; 
        //2. Clear selectedMarketingAutomation reducer; 
        //3. Redirect to list screen
        this.props.editMarketingAutomation(this.props.selectedMarketingAutomation.trigger, this.state, () => {
            this.props.setSelectedMarketingAutomation(null, () => {
                this.props.history.push(`/restaurant/${restaurantId}/marketing-automations`);
            });
        });
    }

    updateEmailTemplateState(currentEmailTemplate) {
        this.setState({
            emailTemplate: currentEmailTemplate
        })
    }

    deleteTrigger = () => {

        //1. Delete promotion; 
        //2. Clear selectedMarketingAutomation reducer; 
        //3. Redirect to list screen
        const restaurantId = this.props.match.params.id;
        const promotionId = this.props.selectedMarketingAutomation.trigger.id;

        this.props.deletePromotion(promotionId, () => {
            this.props.setSelectedMarketingAutomation(null, () => {
                this.props.history.push(`/restaurant/${restaurantId}/marketing-automations`);
            });
        });
    }

    clearSelectedFilter = key => {
        switch (key) {
            case 'customerStatus': this.setState({ filters: { ...this.state.filters, customerStatus: null } });
                return;
            case 'vip': this.setState({ filters: { ...this.state.filters, vip: null } });
                return;
            case 'orderCount': this.setState({ filters: { ...this.state.filters, minOrderCount: null, maxOrderCount: null } });
                return;
            case 'averageOrderValue': this.setState({ filters: { ...this.state.filters, minAverageOrderValue: null, maxAverageOrderValue: null } });
                return;
            case 'lifetimeOrderValue': this.setState({ filters: { ...this.state.filters, minLifetimeOrderValue: null, maxLifetimeOrderValue: null } });
                return;
            case 'orderFrequency': this.setState({ filters: { ...this.state.filters, minOrderFrequency: null, maxOrderFrequency: null } });
                return;
            case 'firstOrder': this.setState({ filters: { ...this.state.filters, firstOrderStartDate: null, firstOrderEndDate: null } });
                return;
            case 'lastOrder': this.setState({ filters: { ...this.state.filters, lastOrderStartDate: null, lastOrderEndDate: null } });
                return;
            case 'lastContact': this.setState({ filters: { ...this.state.filters, lastContactStartRange: null, lastContactEndRange: null } });
                return;
            case 'hourOfDay': this.setState({ filters: { ...this.state.filters, minHourOfDay: null, maxHourOfDay: null } });
                return;
            case 'dayOfWeek': this.setState({ filters: { ...this.state.filters, minDayOfWeek: null, maxDayOfWeek: null } });
                return;
            case 'redeemed': this.setState({ filters: { ...this.state.filters, redeemed: null } });
                return;
            case 'productPosId': this.setState({ filters: { ...this.state.filters, productPosId: null } });
                return;
            case 'promotionId': this.setState({ filters: { ...this.state.filters, promotionId: null } });
                return;
            case 'orderTypeCollection': this.setState({ filters: { ...this.state.filters, orderTypeCollection: [] } });
                return;
            case 'paymentTypeCollection': this.setState({ filters: { ...this.state.filters, paymentTypeCollection: [] } });
                return;
            case 'sourceTypeCollection': this.setState({ filters: { ...this.state.filters, sourceTypeCollection: [] } });
                return;
            default: return;
        }
    }

    renderNameField = () => {
        const { inputWrapper, inputFields } = styles;

        return (
            <div style={inputWrapper}>
                <AvField style={inputFields} name="name" id="name"
                    value={this.state.name}
                    onChange={this.changeState}
                    errorMessage={i18n.t('common:validations.errorMsg')} 
                    maxLength={64}/>
            </div>
        );
    }

    renderDescriptionArea = () => {

        const { inputWrapper, inputArea } = styles;
        return (
            <div style={inputWrapper}>
                <AvInput style={inputArea} type="textarea" name="description" id="description" className="thinScrollbar"
                    value={this.state.description}
                    onChange={this.changeState}
                    errorMessage={i18n.t('common:validations.errorMsg')}
                    maxLength={1000}
                />
            </div>
        );

    }

    renderNameDescription = () => {
        const { sectionDiv, flexSpaceBetween } = styles;

        return (
            <div style={sectionDiv}>
                <div style={{ ...flexSpaceBetween, paddingRight: '10px' }}>
                    <SectionTitle title={i18n.t('screens:marketingAutomationScreen.name')} />
                    <LabeledToggleElement
                        icon={null}
                        text={i18n.t('screens:marketingAutomationScreen.active')}
                        toggleChecked={this.state.active}
                        toggleOnChange={this.changeActiveFlag}
                        spaceBetween={5}
                        flexEnd={false}
                        editMode={false}
                    />
                </div>
                {this.renderNameField()}
                <SectionTitle title={i18n.t('screens:marketingAutomationScreen.description')} />
                {this.renderDescriptionArea()}
            </div>
        );
    }

    renderDateField = (dateNumber, dateValue) => {

        const { flexSpaceBetween, flexCenter } = styles;

        return (
            <div style={flexSpaceBetween}>
                <div style={flexCenter}>
                    <span style={{ fontWeight: 'bold' }}>
                        {this.renderDayText(dateNumber)}
                    </span>
                </div>
                <div style={{ paddingTop: '5px' }}>
                    {this.renderDateSelectOption(dateNumber, dateValue)}
                </div>
            </div>
        );

    }

    renderDayText = dateNumber => {
        switch (dateNumber) {
            case 1: return i18n.t('screens:marketingAutomationScreen.sunday');
            case 2: return i18n.t('screens:marketingAutomationScreen.monday');
            case 3: return i18n.t('screens:marketingAutomationScreen.tuesday');
            case 4: return i18n.t('screens:marketingAutomationScreen.wednesday');
            case 5: return i18n.t('screens:marketingAutomationScreen.thursday');
            case 6: return i18n.t('screens:marketingAutomationScreen.friday');
            case 7: return i18n.t('screens:marketingAutomationScreen.saturday');
            
            case '1': return i18n.t('screens:marketingAutomationScreen.monday');
            case '2': return i18n.t('screens:marketingAutomationScreen.tuesday');
            case '3': return i18n.t('screens:marketingAutomationScreen.wednesday');
            case '4': return i18n.t('screens:marketingAutomationScreen.thursday');
            case '5': return i18n.t('screens:marketingAutomationScreen.friday');
            case '6': return i18n.t('screens:marketingAutomationScreen.saturday');
            case '7': return i18n.t('screens:marketingAutomationScreen.sunday');

            default: return i18n.t('screens:marketingAutomationScreen.sunday');
        }
    }

    renderDateSelectOption = (dateNumber, dateValue) => {

        const { selectWithFixedWidth } = styles;

        switch (dateNumber) {
            case 1:
                return (
                    <AvField style={selectWithFixedWidth} type="select" disabled={this.state.editMode} id={`day${dateNumber}`} name={`day${dateNumber}`} value={dateValue} onChange={this.changeState}>
                        <option value={null}></option>
                        <option value={12}>12:00</option>
                        <option value={13}>13:00</option>
                        <option value={14}>14:00</option>
                        <option value={15}>15:00</option>
                        <option value={16}>16:00</option>
                        <option value={17}>17:00</option>
                    </AvField>
                );
            case 7:
                return (
                    <AvField style={selectWithFixedWidth} type="select" disabled={this.state.editMode} id={`day${dateNumber}`} name={`day${dateNumber}`} value={dateValue} onChange={this.changeState} required>
                        <option value={12}>12:00</option>
                        <option value={13}>13:00</option>
                        <option value={14}>14:00</option>
                        <option value={15}>15:00</option>
                        <option value={16}>16:00</option>
                        <option value={17}>17:00</option>
                    </AvField>
                );
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            default:
                return (
                    <AvField style={selectWithFixedWidth} type="select" disabled={this.state.editMode} id={`day${dateNumber}`} name={`day${dateNumber}`} value={dateValue} onChange={this.changeState} required>
                        <option value={9}>09:00</option>
                        <option value={10}>10:00</option>
                        <option value={11}>11:00</option>
                        <option value={12}>12:00</option>
                        <option value={13}>13:00</option>
                        <option value={14}>14:00</option>
                        <option value={15}>15:00</option>
                        <option value={16}>16:00</option>
                        <option value={17}>17:00</option>
                        <option value={18}>18:00</option>
                    </AvField>
                );
        }
    }

    renderFilters = () => {
        const { sectionDiv, flexSpaceBetween, noteStyle, contentSpacing } = styles;

        return (
            <div style={sectionDiv}>
                <div style={flexSpaceBetween}>
                    <SectionTitle title={i18n.t('screens:marketingAutomationScreen.audience')} />
                    <div style={{ display: 'flex' }}>
                        {this.renderAddFilterButton()}
                        <InformationTooltip
                            message={i18n.t('screens:marketingAutomationScreen.notEditable')}
                            targetId="filters" />
                    </div>
                </div>
                <div style={{ ...contentSpacing, paddingBottom: 0 }}>
                    <div style={noteStyle}>
                        {i18n.t('screens:marketingAutomationScreen.selectFiltersNote')}
                    </div>
                    <div style={{ minHeight: '110px' }}>
                        {this.renderSelectedFilters()}
                    </div>
                    {this.renderFilterResuls()}
                </div>
                {this.renderCustomerListResults()}
            </div>
        );
    }

    renderAddFilterButton = () => {
        if (this.state.editMode) {
            return null;
        }

        return (
            <React.Fragment>
                <SearchButton onClick={this.toggleFilterModal} text={i18n.t('screens:marketingAutomationScreen.addFilter')} plusIcon={true} />
            </React.Fragment>
        );
    }
    
    renderSelectedFilters = () => {
        let filterSectionsTexts = [];
        const { filters } = this.state;

        if (filters.customerStatus !== null) {
            let value = '';
            switch (filters.customerStatus) {
                case 'BIG_SPENDER': value = `${i18n.t('screens:marketingAutomationScreen.customerStatus')}: ${i18n.t('screens:customerInsightScreen.bigSpender')}`;
                    break;
                case 'REGULAR': value = `${i18n.t('screens:marketingAutomationScreen.customerStatus')}: ${i18n.t('screens:customerInsightScreen.regular')}`;
                    break;
                case 'INFREQUENT': value = `${i18n.t('screens:marketingAutomationScreen.customerStatus')}: ${i18n.t('screens:customerInsightScreen.infrequent')}`;
                    break;
                case 'AT_RISK': value = `${i18n.t('screens:marketingAutomationScreen.customerStatus')}: ${i18n.t('screens:customerInsightScreen.atRisk')}`;
                    break;
                case 'LOST': value = `${i18n.t('screens:marketingAutomationScreen.customerStatus')}: ${i18n.t('screens:customerInsightScreen.lost')}`;
                    break;
                default: break;
            }
            filterSectionsTexts.push({ key: 'customerStatus', value });
        }

        if (filters.vip !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.vipStatus')}: ${filters.vip === 'true' || filters.vip === true ? i18n.t('screens:marketingAutomationScreen.vipCustomers') : i18n.t('screens:marketingAutomationScreen.noVipCustomers')}`;
            filterSectionsTexts.push({ key: 'vip', value });
        }

        if (filters.minOrderCount !== null && filters.maxOrderCount != null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.orderCount')} ${i18n.t('screens:marketingAutomationScreen.between')} ${filters.minOrderCount} ${i18n.t('screens:marketingAutomationScreen.and')} ${filters.maxOrderCount}`;
            filterSectionsTexts.push({ key: 'orderCount', value });
        } else if (filters.minOrderCount !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.orderCount')} ${i18n.t('screens:marketingAutomationScreen.moreThan')} ${filters.minOrderCount}`;
            filterSectionsTexts.push({ key: 'orderCount', value });

        } else if (filters.maxOrderCount !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.orderCount')} ${i18n.t('screens:marketingAutomationScreen.lessThan')} ${filters.maxOrderCount}`;
            filterSectionsTexts.push({ key: 'orderCount', value });
        }

        if (filters.minAverageOrderValue !== null && filters.maxAverageOrderValue != null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.averageOrderValue')} ${i18n.t('screens:marketingAutomationScreen.between')} ${filters.minAverageOrderValue} ${i18n.t('screens:marketingAutomationScreen.and')} ${filters.maxAverageOrderValue}`;
            filterSectionsTexts.push({ key: 'averageOrderValue', value });
        } else if (filters.minAverageOrderValue !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.averageOrderValue')} ${i18n.t('screens:marketingAutomationScreen.moreThan')} ${filters.minAverageOrderValue}`;
            filterSectionsTexts.push({ key: 'averageOrderValue', value });
        } else if (filters.maxAverageOrderValue !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.averageOrderValue')} ${i18n.t('screens:marketingAutomationScreen.lessThan')} ${filters.maxAverageOrderValue}`;
            filterSectionsTexts.push({ key: 'averageOrderValue', value });
        }

        if (filters.minLifetimeOrderValue !== null && filters.maxLifetimeOrderValue != null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.lifetimeOrderValue')} ${i18n.t('screens:marketingAutomationScreen.between')} ${filters.minLifetimeOrderValue} ${i18n.t('screens:marketingAutomationScreen.and')} ${filters.maxLifetimeOrderValue}`;
            filterSectionsTexts.push({ key: 'lifetimeOrderValue', value });
        } else if (filters.minLifetimeOrderValue !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.lifetimeOrderValue')} ${i18n.t('screens:marketingAutomationScreen.moreThan')} ${filters.minLifetimeOrderValue}`;
            filterSectionsTexts.push({ key: 'lifetimeOrderValue', value });
        } else if (filters.maxLifetimeOrderValue !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.lifetimeOrderValue')} ${i18n.t('screens:marketingAutomationScreen.lessThan')} ${filters.maxLifetimeOrderValue}`;
            filterSectionsTexts.push({ key: 'lifetimeOrderValue', value });
        }

        if (filters.minOrderFrequency !== null && filters.maxOrderFrequency != null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.orderFrequency')} ${i18n.t('screens:marketingAutomationScreen.between')} ${filters.minOrderFrequency} ${i18n.t('screens:marketingAutomationScreen.and')} ${filters.maxOrderFrequency}`;
            filterSectionsTexts.push({ key: 'orderFrequency', value });
        } else if (filters.minOrderFrequency !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.orderFrequency')} ${i18n.t('screens:marketingAutomationScreen.moreThan')} ${filters.minOrderFrequency}`;
            filterSectionsTexts.push({ key: 'orderFrequency', value });
        } else if (filters.maxOrderFrequency !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.orderFrequency')} ${i18n.t('screens:marketingAutomationScreen.lessThan')} ${filters.maxOrderFrequency}`;
            filterSectionsTexts.push({ key: 'orderFrequency', value });
        }

        if (filters.firstOrderStartDate !== null && filters.firstOrderEndDate != null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.firstOrder')} ${i18n.t('screens:marketingAutomationScreen.between')} ${filters.firstOrderStartDate} ${i18n.t('screens:marketingAutomationScreen.and')} ${filters.firstOrderEndDate}`;
            filterSectionsTexts.push({ key: 'firstOrder', value });
        } else if (filters.firstOrderStartDate !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.firstOrder')} ${i18n.t('screens:marketingAutomationScreen.after')} ${filters.firstOrderStartDate}`;
            filterSectionsTexts.push({ key: 'firstOrder', value });
        } else if (filters.firstOrderEndDate !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.firstOrder')} ${i18n.t('screens:marketingAutomationScreen.before')} ${filters.firstOrderEndDate}`;
            filterSectionsTexts.push({ key: 'firstOrder', value });
        }

        if (filters.lastOrderStartDate !== null && filters.lastOrderEndDate != null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.lastOrder')} ${i18n.t('screens:marketingAutomationScreen.between')} ${filters.lastOrderStartDate} ${i18n.t('screens:marketingAutomationScreen.and')} ${filters.lastOrderEndDate}`;
            filterSectionsTexts.push({ key: 'lastOrder', value });
        } else if (filters.lastOrderStartDate !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.lastOrder')} ${i18n.t('screens:marketingAutomationScreen.after')} ${filters.lastOrderStartDate}`;
            filterSectionsTexts.push({ key: 'lastOrder', value });
        } else if (filters.lastOrderEndDate !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.lastOrder')} ${i18n.t('screens:marketingAutomationScreen.before')} ${filters.lastOrderEndDate}`;
            filterSectionsTexts.push({ key: 'lastOrder', value });
        }

        if (filters.lastContactStartRange !== null && filters.lastContactEndRange != null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.lastNotification')} ${i18n.t('screens:marketingAutomationScreen.between')} ${filters.lastContactStartRange} ${i18n.t('screens:marketingAutomationScreen.and')} ${filters.lastContactEndRange} ${i18n.t('screens:marketingAutomationScreen.days')}`;
            filterSectionsTexts.push({ key: 'lastContact', value });
        } else if (filters.lastContactStartRange !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.lastNotification')} ${i18n.t('screens:marketingAutomationScreen.moreThan')} ${filters.lastContactStartRange} ${i18n.t('screens:marketingAutomationScreen.days')}`;
            filterSectionsTexts.push({ key: 'lastContact', value });
        } else if (filters.lastContactEndRange !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.lastNotification')} ${i18n.t('screens:marketingAutomationScreen.lessThan')} ${filters.lastContactEndRange} ${i18n.t('screens:marketingAutomationScreen.days')}`;
            filterSectionsTexts.push({ key: 'lastContact', value });
        }

        if (filters.minHourOfDay !== null && filters.maxHourOfDay != null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.hourOfDay')} ${i18n.t('screens:marketingAutomationScreen.between')} ${filters.minHourOfDay} ${i18n.t('screens:marketingAutomationScreen.and')} ${filters.maxHourOfDay}`;
            filterSectionsTexts.push({ key: 'hourOfDay', value });
        } else if (filters.minHourOfDay !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.hourOfDay')} ${i18n.t('screens:marketingAutomationScreen.after')} ${filters.minHourOfDay}`;
            filterSectionsTexts.push({ key: 'hourOfDay', value });
        } else if (filters.maxHourOfDay !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.hourOfDay')} ${i18n.t('screens:marketingAutomationScreen.before')} ${filters.maxHourOfDay}`;
            filterSectionsTexts.push({ key: 'hourOfDay', value });
        }

        if (filters.minDayOfWeek !== null && filters.maxDayOfWeek !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.dayOfWeek')} ${i18n.t('screens:marketingAutomationScreen.between')} ${this.renderDayText(filters.minDayOfWeek.toString())} ${i18n.t('screens:marketingAutomationScreen.and')} ${this.renderDayText(filters.maxDayOfWeek.toString())}`;
            filterSectionsTexts.push({ key: 'dayOfWeek', value });
        } else if (filters.minDayOfWeek !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.dayOfWeek')} ${i18n.t('screens:marketingAutomationScreen.after')} ${this.renderDayText(filters.minDayOfWeek.toString())}`;
            filterSectionsTexts.push({ key: 'dayOfWeek', value });
        } else if (filters.maxDayOfWeek !== null) {
            const value = `${i18n.t('screens:marketingAutomationScreen.dayOfWeek')} ${i18n.t('screens:marketingAutomationScreen.before')} ${this.renderDayText(filters.maxDayOfWeek.toString())}`;
            filterSectionsTexts.push({ key: 'dayOfWeek', value });
        }

        if (filters.redeemed !== null) {
            let value = '';
            filters.redeemed === 'true' ? value = i18n.t('screens:marketingAutomationScreen.withRedeemed') : value = i18n.t('screens:marketingAutomationScreen.withUnredeemed');
            filterSectionsTexts.push({ key: 'redeemed', value });
        }

        if (filters.productPosId !== null) {

            let productName = '';
            if (this.props.products !== null) {
                const productsArr = this.props.products.filter(obj => { return obj.posId === filters.productPosId })
                if (productsArr.length > 0) {
                    productName = productsArr[0].name;
                }
            }

            const value = `${i18n.t('screens:marketingAutomationScreen.productWithName')} ${productName}`;
            filterSectionsTexts.push({ key: 'productPosId', value });
        }

        if (filters.promotionId !== null) {

            let promotionName = '';
            if (this.props.promotions !== null) {
                const promotionsArr = this.props.promotions.filter(obj => { return obj.id === filters.promotionId })
                if (promotionsArr.length > 0) {
                    promotionName = promotionsArr[0].name;
                }
            }

            const value = `${i18n.t('screens:marketingAutomationScreen.promotionWithName')} ${promotionName}`;
            filterSectionsTexts.push({ key: 'promotionId', value });
        }

        if (filters.orderTypeCollection.length !== 0) {
            const value = `${i18n.t('screens:marketingAutomationScreen.orderTypesPlaced')} ${this.concatenateNamesFromCollection(1, filters.orderTypeCollection)}`;
            filterSectionsTexts.push({ key: 'orderTypeCollection', value });
        }

        if (filters.paymentTypeCollection.length !== 0) {
            const value = `${i18n.t('screens:marketingAutomationScreen.paymentTypesPlaced')} ${this.concatenateNamesFromCollection(2, filters.paymentTypeCollection)}`;
            filterSectionsTexts.push({ key: 'paymentTypeCollection', value });
        }

        if (filters.sourceTypeCollection.length !== 0) {
            const value = `${i18n.t('screens:marketingAutomationScreen.sourceTypesPlaced')} ${this.concatenateNamesFromCollection(3, filters.sourceTypeCollection)}`;
            filterSectionsTexts.push({ key: 'sourceTypeCollection', value });
        }

        return filterSectionsTexts.map((text, index) => {
            return (
                <React.Fragment key={index}>
                    {this.renderSingleFilter(text, index)}
                </React.Fragment>
            );
        })
    }

    renderSingleFilter = (text, index) => {

        const { singleFilter, } = styles;

        if (this.state.editMode) {
            return (
                <div key={index} style={singleFilter}>
                    {text.value}
                </div>
            );
        }

        return (
            <div key={index} style={singleFilter}>
                {`${text.value} `}
                <span style={{ cursor: 'pointer' }} onClick={() => this.clearSelectedFilter(text.key)} >
                    <MaterialIcon icon='cancel' size={18} color={'#0288d1'} />
                </span>
            </div>
        );
    }

    concatenateNamesFromCollection = (collectionType, collection) => {
        //CollectionType 1 - orderTypes; 2 - paymentTypes; 3 - sourceTypes

        let concatenation = '';
        collection.map(obj => {
            if (collectionType === 1) {
                let typeName = '';
                if (obj.id === 1) {
                    typeName = i18n.t('screens:marketingAutomationScreen.delivery')
                } else if (obj.id === 2) {
                    typeName = i18n.t('screens:marketingAutomationScreen.pickUp')
                } else if (obj.id === 4) {
                    typeName = i18n.t('screens:marketingAutomationScreen.curbside')
                } else if (obj.id === 5) {
                    typeName = i18n.t('screens:marketingAutomationScreen.inStore')
                }
                concatenation += ` ${typeName},`;
            } else if (collectionType === 2) {
                let typeName = '';
                if (obj.id === 1) {
                    typeName = i18n.t('screens:marketingAutomationScreen.creditCard')
                } else if (obj.id === 2) {
                    typeName = i18n.t('screens:marketingAutomationScreen.cash')
                } else if (obj.id === 3) {
                    typeName = i18n.t('screens:marketingAutomationScreen.loyalty')
                } else if (obj.id === 4) {
                    typeName = i18n.t('screens:marketingAutomationScreen.giftCard')
                }
                concatenation += ` ${typeName},`;
            } else {
                concatenation += ` ${obj.name},`;
            }
        })

        if (concatenation !== '') {
            concatenation = concatenation.slice(0, -1);
        }

        return concatenation;
    }

    renderFilterResuls = () => {
        const { noteStyle, filterResultStyle, linkStyle } = styles;

        if (!this.state.editMode) {
            return (
                <Row style={{ margin: 0 }}>
                    <Col sm={8} style={{ padding: 0 }}>
                        <div style={{ ...noteStyle, paddingBottom: 0, paddingTop: '10px' }}>
                            {i18n.t('screens:marketingAutomationScreen.estimateAudienceNote')}
                        </div>
                    </Col>
                    <Col sm={4} style={{display: 'flex', justifyContent: 'flex-end', paddingRight: '0px'}}>
                        <div style={{...filterResultStyle, paddingRight: '5px'}}>
                            {this.props.initialAudience}
                        </div>
                        <div style={linkStyle} onClick={() => this.loadInitialCustomerCount()}>
                            {i18n.t('screens:marketingAutomationScreen.update')}
                        </div>
                    </Col>
                </Row>
            )

        }
    }

    renderCustomerListResults = () => {
        if (this.state.editMode) {
            return (
                <Col sm={12} style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '0px' }}>
                    <SearchButton onClick={this.toggleCusotmerListModal} text={i18n.t('screens:marketingAutomationScreen.viewAudience')} />
                </Col>
            )
        }
    }

    renderSpecificDiscountOptions = () => {
        switch (this.state.discountType) {
            case 'PRICE_DISCOUNT': return this.renderPriceDiscountOptions();
            case 'FREE_PRODUCT': return this.renderFreeProductOptions();
            case 'COMBO_DEAL': return this.renderComboDealOptions();
        }
    }

    renderPriceDiscountOptions = () => {

        const { verticleCenter, bold, inputWithFixedWidth } = styles;
        const sign = this.state.priceDiscount.discountInPercentage ? `%`
            : `${getCurrencySymbol(this.props.restaurant.currency)}`;

        return (
            <Row style={{ display: 'flex', alignItems: 'center', margin: 0, paddingTop: '15px' }}>
                <Col sm={5} style={{ padding: 0 }}>
                    <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                        <Label style={bold} for="priceDiscountAmount" >{i18n.t('screens:marketingAutomationScreen.discount')}</Label>
                        <AvField
                            style={inputWithFixedWidth} type="number" name="priceDiscountAmount" id="priceDiscountAmount"
                            min={0}
                            value={this.getValue(this.state.priceDiscount.discountAmount)}
                            onChange={this.changePriceDiscountAmount}
                            disabled={this.state.editMode}
                        />
                        <Label for="priceDiscountAmount" style={{...bold}}>{sign}</Label>
                    </div>
                </Col>
                <Col sm={1} ></Col>
                <Col sm={5} style={{ padding: 0 }}>
                    <LabeledToggleElement
                        icon={null}
                        text={i18n.t('screens:marketingAutomationScreen.discountInPercentage')}
                        toggleChecked={this.state.priceDiscount.discountInPercentage}
                        toggleOnChange={this.changePriceDiscountInPercentage}
                        spaceBetween={15}
                        flexEnd={false}
                        editMode={this.state.editMode}
                    />
                </Col>
            </Row>
        );
    }

    renderFreeProductOptions = () => {

        const { bold, inputWithFixedWidth, verticleCenter } = styles;

        return (
            <Row style={{ margin: 0, paddingTop: '15px' }}>
                <Col sm={8} style={{ padding: 0 }}>
                    <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                        <Label for="productName" style={{ ...bold, margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.product')}</Label>
                        <Input style={{ ...inputWithFixedWidth, width: '200px' }} type="text" name="productName" id="productName"
                            autoComplete="off"
                            min={0}
                            value={this.state.freeProduct.productName}
                            onChange={this.changeFreeProductName}
                            onKeyUp={(e) => this.handleKeyUp(e)}
                            onBlur={() => this.handleAutoSearchFocusOut()}
                            disabled={this.state.editMode}
                        />
                    </div>
                </Col>
                <Col sm={4} style={{ padding: 0 }}>
                    <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                        <Label for="discountQuantity" style={{ ...bold, margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.quantity')}</Label>
                        <Input style={inputWithFixedWidth} type="number" name="discountQuantity" id="discountQuantity"
                            min={0}
                            onChange={this.changeFreeproductQuantity}
                            value={this.getValue(this.state.freeProduct.quantity)}
                            disabled={this.state.editMode}
                        />
                    </div>
                </Col>
                {this.state.matchedFromSearch.length ? this.renderSearchResults() : ''}
            </Row>

        );
    }

    //Auto search components and fuctions from here
    handleKeyUp = (e) => {
        this.handleAutoSearch();
        //If backspace or delete pressed trigger the autosearch
        let keyCode = e.keyCode;
        let searchedProductToString = String(this.state.freeProduct.productName);

        if (keyCode === 8 || keyCode === 46) {
            if (searchedProductToString.length >= 3) {
                this.handleAutoSearch();
            } else {
                let emptyMatchedFromSearchArray = this.state.matchedFromSearch.filter((product) => null);
                this.setState({ ...this.state, matchedFromSearch: emptyMatchedFromSearchArray });
            }
        }
    }

    handleAutoSearchFocusOut = () => {
        let searchedProduct = String(this.state.freeProduct.productName);

        if (searchedProduct.length < 3) {
            let emptyMatchedFromSearchArray = this.state.matchedFromSearch.filter((product) => null);
            this.setState({ ...this.state, matchedFromSearch: emptyMatchedFromSearchArray });
        } else {
            // If search string is longer than 2 characters activate the search
            this.handleAutoSearch();
        }
    }

    handleAutoSearch() {
        if (!this.state.products.length) {
            return;
        }

        let searchedProduct = this.state.freeProduct.productName.toLowerCase();
        let searchStringLength = String(this.state.freeProduct.productName).length;
        // Trigger autosearch
        if (searchStringLength >= 3) {
            // filter the products for everyone that has a match with the user input
            let matchedProducts = this.state.products.filter((product) => product.name.toLowerCase().includes(searchedProduct));
            this.setState({ ...this.state, matchedFromSearch: matchedProducts });
        } else {
            let emptyMatchedFromSearchArray = this.state.matchedFromSearch.filter((product) => null);
            this.setState({ ...this.state, matchedFromSearch: emptyMatchedFromSearchArray });
        }
    }

    /* Free Product Autosearch Functions */
    renderSearchResults = () => {
        const { searchResultContainer } = styles;

        return (
            <div style={searchResultContainer}>
                <ul className='auto-search-triggers'>
                    {
                        this.state.matchedFromSearch.map((result) => {
                            return <li key={result.id} onClick={() => this.getProductName(result.name, result.id)}>{result.name}</li>
                        })
                    }
                </ul>
            </div>
        );
    }

    getProductName(selectedProductName, selectedProductId) {
        let emptyMatchedFromSearchArray = this.state.matchedFromSearch.filter((product) => null);
        this.setState({ freeProduct: { productId: selectedProductId, productName: selectedProductName, quantity: this.state.freeProduct.quantity }, matchedFromSearch: emptyMatchedFromSearchArray });
    }
    //Auto search components and fuctions to here

    renderComboDealOptions = () => {
        const { verticleCenter, bold, inputWithFixedWidth, flexSpaceBetween } = styles;
        let text, sign;

        if(this.state.comboDeal.valueInPercentage && this.state.comboDeal.valueIsDiscount) {
            text = i18n.t('screens:marketingAutomationScreen.withDiscount');
            sign = `% ${i18n.t('screens:marketingAutomationScreen.each')}`

        } else if(!this.state.comboDeal.valueInPercentage && this.state.comboDeal.valueIsDiscount) {
            text = i18n.t('screens:marketingAutomationScreen.withDiscount');
            sign = `${getCurrencySymbol(this.props.restaurant.currency)} ${i18n.t('screens:marketingAutomationScreen.each')}`

        } else if(this.state.comboDeal.valueInPercentage && !this.state.comboDeal.valueIsDiscount) {
            text = i18n.t('screens:marketingAutomationScreen.for');
            sign = `% ${i18n.t('screens:marketingAutomationScreen.each')}`

        } else if(!this.state.comboDeal.valueInPercentage && !this.state.comboDeal.valueIsDiscount) {
            text = i18n.t('screens:marketingAutomationScreen.for');
            sign = `${getCurrencySymbol(this.props.restaurant.currency)} ${i18n.t('screens:marketingAutomationScreen.each')}`
        }
        

        return (
            <Fragment>
            <Row style={{ margin: '0 0 10px 0' }}>
                {/* <Col sm={4} style={{padding: '0 10px 0 0'}}> */}
                <div style={{marginRight: '20px'}}>
                <LabeledToggleElement
                        icon={null}
                        text={i18n.t('screens:marketingAutomationScreen.valueDiscount')}
                        toggleChecked={this.state.comboDeal.valueIsDiscount}
                        toggleOnChange={this.changeComboDealValueDiscount}
                        spaceBetween={5}
                        flexEnd={false}
                        editMode={this.state.editMode}
                    />
                </div>    
                {/* </Col> */}
                {/* <Col sm={4} style={{padding: '0 10px 0 0'}}> */}
                    <LabeledToggleElement
                        icon={null}
                        text={i18n.t('screens:marketingAutomationScreen.valuePercent')}
                        toggleChecked={this.state.comboDeal.valueInPercentage}
                        toggleOnChange={this.changeComboDealValueInPercent}
                        spaceBetween={5}
                        flexEnd={false}
                        editMode={this.state.editMode}
                    />
                {/* </Col> */}
                {/* <Col sm={4} style={{padding: '0 10px 0 0'}}></Col> */}
            </Row>
            <Row style={{ margin: 0 }}>
                <Col sm={12} style={{ padding: 0 }}>
                    <div style={{ display: 'flex', paddingTop: '5px' }}>
                        <Label for="buyProductsCount" style={{ ...bold, margin: 0 }}>{i18n.t('screens:promotionTypeScreen.buy')}</Label>
                        <Input
                            style={inputWithFixedWidth} type="number" name="buyProductsCount" id="buyProductsCount"
                            min={0}
                            value={this.getValue(this.state.comboDeal.buyProductsCount)}
                            onChange={this.changeComboDealInputs}
                            disabled={this.state.editMode}
                        />
                        <Label for="buyProductsCount" style={{ ...bold, margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.products')}</Label>             
                        {/* <Label for="freeProductsCount" style={{ ...bold, margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.giftProducts')}</Label> */}
                        <Input
                            style={inputWithFixedWidth} type="number" name="freeProductsCount" id="freeProductsCount"
                            min={0}
                            value={this.getValue(this.state.comboDeal.freeProductsCount)}
                            onChange={this.changeComboDealInputs}
                            disabled={this.state.editMode}
                        />
                        <Label for="discountValue" style={{ ...bold, margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.ofThemWith')}</Label>
                    </div>
                    <div style={{ display: 'flex', paddingTop: '5px' }}>
                        <Label for="discountValue" style={{ ...bold, margin: 0 }}>{text}</Label>
                        <Input
                            style={{ ...inputWithFixedWidth, width: '70px' }} type="number" name="discountValue" id="discountValue"
                            min={0}
                            value={this.getValue(this.state.comboDeal.discountValue)}
                            onChange={this.changeComboDealInputs}
                            disabled={this.state.editMode}
                            onKeyPress={(e) => this.comboDealDiscountValidation(e)}
                        />
                        <Label for="discountValue" style={{ ...bold, margin: 0 }}>{sign}</Label>
                    </div>
                </Col>
            </Row >
        </Fragment>
        );
    }

    renderDiscountType = () => {
        const { sectionDiv, contentSpacing, flexSpaceBetween } = styles;

        return (
            <div style={sectionDiv}>
                <div style={flexSpaceBetween}>
                    <SectionTitle title={i18n.t('screens:marketingAutomationScreen.discountType')} />
                    <InformationTooltip
                        message={i18n.t('screens:marketingAutomationScreen.notEditable')}
                        placement="left"
                        targetId="discountType" />
                </div>
                <div style={{...contentSpacing, paddingRight: '10px'}}>

                    <Row style={{ margin: '0 0 10px 0', display: 'flex', justifyContent: 'space-between' }}>
                        <Col sm={4} style={{padding: '0 10px 0 0'}}>
                            <LabeledToggleElement
                                icon={null}
                                text={i18n.t('screens:marketingAutomationScreen.priceDiscount')}
                                toggleChecked={this.state.discountType === 'PRICE_DISCOUNT'}
                                toggleOnChange={this.changeDiscountTypePriceDiscount}
                                spaceBetween={5}
                                flexEnd={false}
                                editMode={this.state.editMode}
                            />
                        </Col>
                        <Col sm={4} style={{padding: '0 10px 0 0'}}>
                            <LabeledToggleElement
                                icon={null}
                                text={i18n.t('screens:marketingAutomationScreen.freeProduct')}
                                toggleChecked={this.state.discountType === 'FREE_PRODUCT'}
                                toggleOnChange={this.changeDiscountTypeFreeProduct}
                                spaceBetween={5}
                                flexEnd={false}
                                editMode={this.state.editMode}
                            />
                        </Col>
                        <Col sm={4} style={{padding: '0 10px 0 0'}}>
                            <LabeledToggleElement
                                icon={null}
                                text={i18n.t('screens:marketingAutomationScreen.comboDeal')}
                                toggleChecked={this.state.discountType === 'COMBO_DEAL'}
                                toggleOnChange={this.changeDiscountTypeComboDeal}
                                spaceBetween={5}
                                flexEnd={false}
                                editMode={this.state.editMode}
                            />
                        </Col>
                    </Row>

                    {this.renderSpecificDiscountOptions()}

                </div>
            </div>
        );
    }

    renderOrderTypes = () => {
        const { sectionDiv, contentSpacing, lineWithSpace } = styles;

        return (
            <div style={sectionDiv}>
                <SectionTitle title={i18n.t('screens:marketingAutomationScreen.orderTypes')} />
                <Row style={{ margin: 0 }}>
                    <Col sm={6} style={{ padding: 0 }}>
                        <div style={contentSpacing}>
                            <LabeledToggleElement
                                icon={<DeliverySVG width={20} height={20} fill={'#0288D1'} />}
                                text={i18n.t('screens:marketingAutomationScreen.delivery')}
                                toggleChecked={this.state.orderTypeDelivery}
                                toggleOnChange={this.changeOrderTypeDelivery}
                                spaceBetween={null}
                                flexEnd={false}
                                editMode={false}
                            />
                            <hr style={lineWithSpace} />
                            <LabeledToggleElement
                                icon={<CurbsideSVG width={20} height={20} fill={'#0288D1'} />}
                                text={i18n.t('screens:marketingAutomationScreen.curbside')}
                                toggleChecked={this.state.orderTypeCurbside}
                                toggleOnChange={this.changeOrderTypeCurbside}
                                spaceBetween={null}
                                flexEnd={false}
                                editMode={false}
                            />
                            <hr style={lineWithSpace} />
                        </div>
                    </Col>
                    <Col sm={6} style={{ padding: 0 }}>
                        <div style={contentSpacing}>
                            <LabeledToggleElement
                                icon={<InStoreSvg width={20} height={20} fill={'#0288D1'} />}
                                text={i18n.t('screens:marketingAutomationScreen.inStore')}
                                toggleChecked={this.state.orderTypeInStore}
                                toggleOnChange={this.changeOrderTypeInStore}
                                spaceBetween={null}
                                flexEnd={false}
                                editMode={false}
                            />
                            <hr style={lineWithSpace} />
                            <LabeledToggleElement
                                icon={<PickUpSVG width={20} height={20} fill={'#0288D1'} />}
                                text={i18n.t('screens:marketingAutomationScreen.pickUp')}
                                toggleChecked={this.state.orderTypeCollection}
                                toggleOnChange={this.changeOrderTypeCollection}
                                spaceBetween={null}
                                flexEnd={false}
                                editMode={false}
                            />
                            <hr style={lineWithSpace} />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    renderNotificationTypes = () => {
        const { sectionDiv, contentSpacing, lineWithSpace } = styles;

        return (
            <div style={sectionDiv}>
                <SectionTitle title={i18n.t('screens:marketingAutomationScreen.notificationTypes')} />
                <div style={contentSpacing}>
                    <LabeledToggleElement
                        icon={<EmailSVG width={25} height={25} fill='#0288d1' />}
                        text={i18n.t('screens:marketingAutomationScreen.email')}
                        toggleChecked={this.state.notificationType === 'EMAIL'}
                        toggleOnChange={this.changeNotificationTypeEmail}
                        spaceBetween={null}
                        flexEnd={false}
                        editMode={false}
                    />
                    <hr style={lineWithSpace} />
                    <LabeledToggleElement
                        icon={<PhoneSVG width={25} height={25} fill='#0288d1' />}
                        text={i18n.t('screens:marketingAutomationScreen.sms')}
                        toggleChecked={this.state.notificationType === 'SMS'}
                        toggleOnChange={this.changeNotificationTypeSms}
                        spaceBetween={null}
                        flexEnd={false}
                        editMode={false}
                    />
                </div>
            </div>
        );
    }

    renderNotificationFrequency = () => {
        const { sectionDiv, contentSpacing, noteStyle, inputWithFixedWidth, verticleCenter, bold, flexSpaceBetween } = styles;

        return (
            <div style={sectionDiv}>
                <div style={flexSpaceBetween}>
                    <SectionTitle title={i18n.t('screens:marketingAutomationScreen.notificationFrequency')} />
                    <InformationTooltip
                        message={i18n.t('screens:marketingAutomationScreen.onceRepeatedNotEditable')}
                        placement="left"
                        targetId="notificationFrequency" />
                </div>
                <div style={{...contentSpacing, paddingBottom: '0px'}}>

                    <div style={noteStyle}>
                        {i18n.t('screens:marketingAutomationScreen.notificationFrequencyNote')}
                    </div>

                    <Row style={{ margin: '0 0 10px 0' }}>
                        <Col sm={3} style={{ padding: 0 }}>
                            <LabeledToggleElement
                                icon={null}
                                text={i18n.t('screens:marketingAutomationScreen.once')}
                                toggleChecked={this.state.notificationFrequency === 'ONCE_FUTURE'}
                                toggleOnChange={this.changeNotificationFrequencyOnce}
                                spaceBetween={25}
                                flexEnd={false}
                                editMode={this.state.editMode}
                            />
                        </Col>
                        <Col sm={1} style={{ padding: 0 }}></Col>
                        <Col sm={3} style={{ padding: 0 }}>
                            <LabeledToggleElement
                                icon={null}
                                text={i18n.t('screens:marketingAutomationScreen.repeated')}
                                toggleChecked={this.state.notificationFrequency === 'REPEAT_FUTURE'}
                                toggleOnChange={this.changeNotificationFrequencyRepeated}
                                spaceBetween={25}
                                flexEnd={false}
                                editMode={this.state.editMode}
                            />
                        </Col>
                    </Row>

                    <Row style={{ margin: 0 }}>
                        <Col sm={6} style={{ padding: 0 }}>
                            <div style={verticleCenter}>
                                <Label style={bold} for="initialNotificationDays" >{i18n.t('screens:marketingAutomationScreen.initialNotificationsIn')}</Label>
                                <AvField
                                    style={inputWithFixedWidth} type="number" name="initialNotificationDays" id="initialNotificationDays"
                                    min={0}
                                    value={this.getValue(this.state.initialNotificationDays)}
                                    onChange={this.changeState}
                                    disabled={this.state.editMode}
                                />
                                <Label style={bold} for="initialNotificationDays">{i18n.t('screens:marketingAutomationScreen.days')}</Label>
                            </div>
                        </Col>

                        <Col sm={1} style={{ padding: 0 }}></Col>

                        <Col sm={5} style={{ padding: 0 }}>
                            <div style={verticleCenter}>
                                <Label style={bold} for="repeatNotificationDays" >{i18n.t('screens:marketingAutomationScreen.repeatNotificationDays')}</Label>
                                <AvField
                                    style={inputWithFixedWidth} type="number" name="repeatNotificationDays" id="repeatNotificationDays"
                                    min={0}
                                    value={this.getValue(this.state.repeatNotificationDays)}
                                    onChange={this.changeState}
                                    disabled={this.state.notificationFrequency === 'ONCE_FUTURE' || this.state.editMode}
                                />
                                <Label style={bold} for="repeatNotificationDays">{i18n.t('screens:marketingAutomationScreen.days')}</Label>
                            </div>
                        </Col>
                    </Row>
                    <div style={{...noteStyle, paddingBottom: '0px'}}>
                        {i18n.t('screens:marketingAutomationScreen.initialNotificationInfo')}
                    </div>
                    <div style={noteStyle}>
                        {i18n.t('screens:marketingAutomationScreen.repeatDayInfo')}
                    </div>
                </div>
            </div>
        );
    }

    renderCoolDownPeriod = () => {
        const { sectionDiv, contentSpacing, noteStyle, bold, inputWithFixedWidth, verticleCenter, flexSpaceBetween } = styles;

        return (
            <div style={sectionDiv}>
                <div style={flexSpaceBetween}>
                    <SectionTitle title={i18n.t('screens:marketingAutomationScreen.coolDownPeriod')} />
                    <InformationTooltip
                        message={i18n.t('screens:marketingAutomationScreen.coolDownPeriodInfo')}
                        placement="left"
                        targetId="coolDownPeriod" />
                </div>
                
                <div style={contentSpacing}>

                    <div style={{ ...noteStyle, minHeight: '60px' }}>
                        {i18n.t('screens:marketingAutomationScreen.coolDownPeriodNote')}
                    </div>

                    <Row style={{ margin: 0 }}>
                        <Col sm={12} style={{ padding: 0 }}>
                            <div style={verticleCenter}>
                                <Label style={bold} for="coolDownPeriod" >{i18n.t('screens:marketingAutomationScreen.coolDownFor')}</Label>
                                <AvField
                                    style={inputWithFixedWidth} type="number" name="coolDownPeriod" id="coolDownPeriod"
                                    min={0}
                                    value={this.getValue(this.state.coolDownPeriod)}
                                    onChange={this.changeState}
                                />
                                <Label style={bold} for="coolDownPeriod">{i18n.t('screens:marketingAutomationScreen.days')}</Label>
                            </div>
                        </Col>
                    </Row>
                    <div style={noteStyle}>
                        {i18n.t('screens:marketingAutomationScreen.coolDownPeriodInfoSub')}
                    </div>
                </div>
            </div>
        );
    }

    renderPromoCodeValidity = () => {
        const { sectionDiv, contentSpacing, noteStyle, inputWithFixedWidth, verticleCenter, bold, flexSpaceBetween } = styles;

        return (
            <div style={sectionDiv}>
                <div style={flexSpaceBetween}>
                    <SectionTitle title={i18n.t('screens:marketingAutomationScreen.promoCodeValidity')} />
                    <InformationTooltip
                        message={i18n.t('screens:marketingAutomationScreen.promoCodeValidityInfo')}
                        placement="left"
                        targetId="promoCodeValidity" />
                </div>
                <div style={contentSpacing}>

                    <div style={{ ...noteStyle, minHeight: '60px' }}>
                        {i18n.t('screens:marketingAutomationScreen.promoCodeValidityNote')}
                    </div>

                    <Row style={{ margin: 0 }}>
                        <Col sm={12} style={{ padding: 0 }}>
                            <div style={verticleCenter}>
                                <Label style={bold} for="promoCodeValidity" >{i18n.t('screens:marketingAutomationScreen.validFor')}</Label>
                                <AvField
                                    style={inputWithFixedWidth} type="number" name="promoCodeValidity" id="promoCodeValidity"
                                    min={0}
                                    value={this.getValue(this.state.promoCodeValidity)}
                                    onChange={this.changeState}
                                />
                                <Label style={bold} for="promoCodeValidity">{i18n.t('screens:marketingAutomationScreen.days')}</Label>
                            </div>
                        </Col>
                    </Row>

                </div>
            </div>
        );
    }

    renderNotificationTimes = () => {
        const { sectionDiv, contentSpacingNoBottom, line, noteStyle, flexSpaceBetween } = styles;
        const day1 = this.state.day1 === null ? null : parseInt(this.state.day1);
        const day2 = this.state.day2 === null ? null : parseInt(this.state.day2);
        const day3 = this.state.day3 === null ? null : parseInt(this.state.day3);
        const day4 = this.state.day4 === null ? null : parseInt(this.state.day4);
        const day5 = this.state.day5 === null ? null : parseInt(this.state.day5);
        const day6 = this.state.day6 === null ? null : parseInt(this.state.day6);
        const day7 = this.state.day7 === null ? null : parseInt(this.state.day7);

        return (
            <div style={{ ...sectionDiv, paddingBottom: 0 }}>
                <div style={flexSpaceBetween}>
                    <SectionTitle title={i18n.t('screens:marketingAutomationScreen.dailyNotificationTimes')} />
                    <InformationTooltip
                        message={i18n.t('screens:marketingAutomationScreen.notEditable')}
                        placement="left"
                        targetId="notificationTimes" />
                </div>
                <Row style={{ margin: 0 }}>
                    <Col sm={6} style={{ padding: 0 }}>
                        <div style={contentSpacingNoBottom}>
                            <div style={{ ...noteStyle, paddingBottom: '20px' }}>
                                {i18n.t('screens:marketingAutomationScreen.notificationTimeNote')}
                            </div>
                            {this.renderDateField(2, day2)}
                            <hr style={line} />
                            {this.renderDateField(3, day3)}
                            <hr style={line} />
                            {this.renderDateField(4, day4)}
                            <hr style={line} />
                        </div>
                    </Col>
                    <Col sm={6} style={{ padding: 0 }}>
                        <div style={contentSpacingNoBottom}>
                            {this.renderDateField(5, day5)}
                            <hr style={line} />
                            {this.renderDateField(6, day6)}
                            <hr style={line} />
                            {this.renderDateField(7, day7)}
                            <hr style={line} />
                            {this.renderDateField(1, day1)}
                            <hr style={line} />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    renderMailTemplates = () => {
        const { id } = this.props.match.params;

        return (
            <EmailTemplateContainer
            styles={styles}
            restaurantId={id}
            updateEmailTemplateState={this.updateEmailTemplateState.bind(this)}
            emailTemplate={this.state.emailTemplate}
            selectedMarketingAutomation={this.props.selectedMarketingAutomation}
            isEditMode={this.state.editMode}
            />
        );
    }

    renderSaveDeleteButtons = () => {

        const { footer, footerButtons } = styles;

        return (
            <div style={footer}>
                <Button style={footerButtons} color="primary" onClick={() => this.saveTrigger()}>
                    {i18n.t('common:buttons.save')}
                </Button>
                <Button style={footerButtons} disabled={!this.state.editMode} color="secondary" onClick={() => this.toggleConfirmationScreen()}>
                    {i18n.t('common:buttons.delete')}
                </Button>
            </div>
        );
    }

    renderFilterModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isFilterModalOpen}
                onToggle={this.toggleFilterModal}
                header={i18n.t('screens:marketingAutomationScreen.filters')}
            >
                <FilterSelectionScreen
                    filters={this.state.filters}
                    toggleModal={this.toggleFilterModal}
                    applyFilters={this.applySelectedFilters}
                    currency={getCurrencySymbol(this.props.restaurant.currency)}
                    products={this.state.products}
                    promotions={this.state.promotions}
                />
            </CustomInsightsModal>
        )
    }

    renderCusotmerListModal = () => {
        const className = this.state.isAddCustomerListModalOpen ? 'addCustomerInsightModal' : 'customerInsightModal';
        const marketingAutomationsId = this.props.selectedMarketingAutomation.trigger ? this.props.selectedMarketingAutomation.trigger.id : null;
        const brandId = this.props.restaurant ? this.props.restaurant.chain.id : null;
        return (
            <CustomInsightsModal
                isOpen={this.state.isCustomerListModalOpen}
                onToggle={this.toggleCusotmerListModal}
                header={this.state.isAddCustomerListModalOpen ? i18n.t('screens:marketingAutomationScreen.addCustomer') : i18n.t('screens:marketingAutomationScreen.audience')}
                className={className}
            >
            <CustomerSearch 
                customers={this.props.customers} 
                maId={marketingAutomationsId} 
                toggleAddCustomerListModalOpen={this.toggleAddCustomerListModalOpen} 
                isAddCustomerListModalOpen={this.state.isAddCustomerListModalOpen}
                toggleUsedPromoCodesModal={this.toggleUsedPromoCodesModal}
                brandId={brandId} />
            </CustomInsightsModal>
        )
    }
    
    renderHelperText = () => {
        const { paragraphStyle } = styles;

        return (
            <Col>
                    <p>You are in the Single <span style={{fontWeight: 'bold'}}>Marketing Automation (MA)</span> screen.</p>
                    <p style={paragraphStyle}>There are several sections:</p>
                    <p style={paragraphStyle}><li><span style={{fontWeight: 'bold'}}>Name and Description section:</span></li></p>
                    <p style={paragraphStyle}><span style={{fontStyle: 'italic', textDecorationLine: 'underline'}}>It contains 3 elements:</span></p>
                    <p style={paragraphStyle}>1. Name field</p>
                    <p style={paragraphStyle}>- place to put the desired name of the MA.</p>
                    <p style={paragraphStyle}>2. Description field</p>
                    <p style={paragraphStyle}>- place to put the desired description to the MA.</p>
                    <p style={paragraphStyle}>3. Active flag</p>
                    <p>- If the flag is enabled customers can apply for the MA, can receive notifications and can user their reward codes. Therefore if the flag is disabled, no new customers will be able to apply for the MA and no notifications will be sent. Reward codes can still be used.</p>
                    <p style={paragraphStyle}><li><span style={{fontWeight: 'bold'}}>Audience section:</span></li></p>
                    <p style={paragraphStyle}><span style={{fontStyle: 'italic', textDecorationLine: 'underline'}}>It contains 3 elements when in Create Mode:</span></p>
                    <p style={paragraphStyle}>1. Add filter button</p>
                    <p style={paragraphStyle}>- It opens a list with all the possible filters. The filters can be chosen and configured only one by one.</p>
                    <p style={paragraphStyle}>2. View selected filters section</p>
                    <p style={paragraphStyle}>- Applied filters are displayed in the selected filter section. There is a "x" button for each filter in order to remove it in case you don't want to use the filter anymore.</p>
                    <p style={paragraphStyle}>3. Estimate initial audience section</p>
                    <p>- At any given moment you can click on the "Update" button in order to check how many customers apply for the currently selected filters.</p>
                    <p style={paragraphStyle}><span style={{fontStyle: 'italic', textDecorationLine: 'underline'}}>It contains 2 elements when in Edit Mode:</span></p>
                    <p style={paragraphStyle}>1. View selected filter section</p>
                    <p style={paragraphStyle}>- In Edit Mode, the selected filter section cannot be modified, you can only see the initially selected filters.</p>
                    <p style={paragraphStyle}>2. View audience button</p>
                    <p style={paragraphStyle}>- The Audience button will open a window where you can browse the currently applied customers, block or unblock them or manually add new customers. Clicking on the information icon next to the customer name reveals information regarding the client's promo codes, if they are used or not, and their expiration date.</p>
                    <p><span style={{fontWeight: 'bold'}}>If the customer is blocked he/she will not be able to use old codes and generate new ones. Also he/she will not receive notifications.</span></p>
                    <p style={paragraphStyle}><li><span style={{fontWeight: 'bold'}}>Discount Type section:</span></li></p>
                    <p style={paragraphStyle}><span style={{fontStyle: 'italic', textDecorationLine: 'underline'}}>It contains 3 elements, each with their own configurations:</span></p>
                    <p style={paragraphStyle}>1. Price Off (Price Discount)</p>
                    <p style={paragraphStyle}>- here a discount can be defined, the amount can be in currency or in percents of the total sum.</p>
                    <p style={paragraphStyle}>2. Free Item (Free Product)</p>
                    <p style={paragraphStyle}>- here can be selected the desired free product and it's quantity.</p>
                    <p style={paragraphStyle}>3. Combo Deal (Meal Deal)</p>
                    <p>- here can be defined how many products must be purchased in order to receive the discount.</p>
                    <p style={paragraphStyle}><li><span style={{fontWeight: 'bold'}}>Order Types section:</span></li></p>
                    <p style={paragraphStyle}><span style={{fontStyle: 'italic', textDecorationLine: 'underline'}}>It contains 4 elements, indicates the possible order types that the customer can use in order to use his/her reward promo code:</span></p>
                    <p style={paragraphStyle}>1. Delivery flag</p>
                    <p style={paragraphStyle}>2. Dine pay flag</p>
                    <p style={paragraphStyle}>3. Curbside flag</p>
                    <p>4. Pick Up flag</p>
                    <p style={paragraphStyle}><li><span style={{fontWeight: 'bold'}}>Notification Type section:</span></li></p>
                    <p style={paragraphStyle}><span style={{fontStyle: 'italic', textDecorationLine: 'underline'}}>It contains 2 elements, only one can be selected:</span></p>
                    <p style={paragraphStyle}>1. Email</p>
                    <p style={paragraphStyle}>- the customer will receive the notification about his/her reward promo codes via email.</p>
                    <p style={paragraphStyle}>2. SMS</p>
                    <p>- the customer will receive the notification about his/her reward promo codes via sms.</p>
                    <p style={paragraphStyle}><li><span style={{fontWeight: 'bold'}}>Notification Frequency section:</span></li></p>
                    <p style={paragraphStyle}><span style={{fontStyle: 'italic', textDecorationLine: 'underline'}}>It contains 3 elements:</span></p>
                    <p style={paragraphStyle}>1. Frequency Type</p>
                    <p style={paragraphStyle}>- can be Once or Repeated. Only one can be selected at a time. The first option "Once" will send just a single notification. The second option "Repeated" will send notifications for as many days are selected.</p>
                    <p style={paragraphStyle}>2. Initial Notification time</p>
                    <p style={paragraphStyle}>- when to send the notification for the first time after the customer applies for the MA.</p>
                    <p style={paragraphStyle}>3. Repeat Notification frequency</p>
                    <p style={paragraphStyle}>- after how many days will send a new notification.</p>
                    <p><span style={{fontWeight: 'bold'}}>Initial notification time and Repeat notification frequency can be used simultaneously. If both options are defined the repeat of sending notifications will begin after the initial notification. E.g. Initial notification is defined for today ( by entering 0 days in the field ) and the Repeat option is defined for every 2 days. The repetition of notifications will begin 2 days after the initial message.</span></p>
                    <p style={paragraphStyle}><li><span style={{fontWeight: 'bold'}}>Customer Cool Down Period section:</span></li></p>
                    <p style={paragraphStyle}><span style={{fontStyle: 'italic', textDecorationLine: 'underline'}}>It contains 1 element:</span></p>
                    <p style={paragraphStyle}>1. Cool down field</p>
                    <p style={paragraphStyle}>- can be selected how many days a customer will be excluded from reentering this MA.</p>
                    <p><span style={{fontWeight: 'bold'}}>E.g. Cool Down period is set to 5. When I qualify for the automation today, I will not be able to qualify again in the next 5 days.</span></p>
                    <p style={paragraphStyle}><li><span style={{fontWeight: 'bold'}}>Promo Code Validity section:</span></li></p>
                    <p style={paragraphStyle}><span style={{fontStyle: 'italic', textDecorationLine: 'underline'}}>It contains 1 element:</span></p>
                    <p style={paragraphStyle}>1. Promo Code Validity field</p>
                    <p style={paragraphStyle}>- can be selected how many days the promo code will be valid.</p>
                    <p><span style={{fontWeight: 'bold'}}>If more than one promo code is active (not expired and not used), it sends notification for the one that will expire first.</span></p>
                    <p style={paragraphStyle}><li><span style={{fontWeight: 'bold'}}>Daily Notification Times section:</span></li></p>
                    <p style={paragraphStyle}><span style={{fontStyle: 'italic', textDecorationLine: 'underline'}}>It contains 7 elements for each day of the week:</span></p>
                    <p style={paragraphStyle}>1. Dropdown fields for Monday to Friday</p>
                    <p style={paragraphStyle}>- the possible values are the hours from 09:00 to 18:00</p>
                    <p style={paragraphStyle}>2. Dropdown field for Saturday</p>
                    <p style={paragraphStyle}>- the possible values are the hours from 12:00 to 17:00</p>
                    <p style={paragraphStyle}>3. Dropdown field for Sunday</p>
                    <p style={paragraphStyle}>- the possible values are the hours from 12:00 to 17:00. It have the option to leave it empty.</p>
                    <p><span style={{fontWeight: 'bold'}}>The times are configured in the Restaurant Time Zone.</span></p>
                    <p style={paragraphStyle}><li><span style={{fontWeight: 'bold'}}>Email Template section:</span></li></p>
                    <p style={paragraphStyle}><span style={{fontStyle: 'italic', textDecorationLine: 'underline'}}>It contains 3 main elements:</span></p>
                    <p style={paragraphStyle}>1. Email Template, contains the following elements</p>
                    <p style={paragraphStyle}>1.1. Add Image - this is the place where you can upload an image to your email template.</p>
                    <p style={paragraphStyle}>- With Upload Button, we can upload images up to 10MB size, which we can use as sections in the Email Template or as the background of the Email Template.</p>
                    <p style={paragraphStyle}>- The selected image should be with a normal opacity and have a red border to distinguish it as selected. Also, a selected image cannot be deleted, so there is no delete button.</p>
                    <p style={paragraphStyle}>- The unselected image should have opacity and а delete button.</p>
                    <p style={paragraphStyle}>- Redirect Url is a field where you add a URL that will be opened in a new page when the image is clicked.</p>
                    <p style={paragraphStyle}>The Add Button adds an image section in the Navigation Panel.</p>
                    <p>Cancel Button removes the selected image and clears the Redirect Url field.</p>
                    <p style={paragraphStyle}>1.2. Add Text - this is the place where you can add a text to your email template.</p>
                    <p style={paragraphStyle}>There are several available settings that can be defined:</p>
                    <p style={paragraphStyle}>- Alignment (Left, Right or Center)</p>
                    <p style={paragraphStyle}>- Text Size</p>
                    <p style={paragraphStyle}>- Text Family is a dropdown field where you can choose between several types of font style</p>
                    <p style={paragraphStyle}>(<span style={{fontFamily: 'Roboto'}}>Roboto</span>, <span style={{fontFamily: 'Oswald'}}>Oswald</span>, <span style={{fontFamily: 'Anton'}}>Anton</span>, <span style={{fontFamily: 'Wobster'}}>Wobster</span>, <span style={{fontFamily: 'Arvo'}}>Arvo</span>, <span style={{fontFamily: 'Abril Fatface'}}>Abril Fatface</span>, <span style={{fontFamily: 'Amatic SC'}}>Amatic SC</span>, <span style={{fontFamily: 'Special Elite'}}>Special Elite</span>, <span style={{fontFamily: 'Russo One'}}>Russo One</span>)</p>
                    <p style={paragraphStyle}>- The text can be normal, <span style={{fontWeight: 'bold'}}>Bold</span> or <span style={{fontStyle: 'italic'}}>Italic</span>.</p>
                    <p style={paragraphStyle}>- The text field is required if you want to add the Section.</p>
                    <p style={paragraphStyle}>The Add Button adds a text section in the Navigation Panel.</p>
                    <p>The Cancel Button clears all fields in the section.</p>
                    <p style={paragraphStyle}>1.3. Background - this is the place where you can upload a background image to your email template.</p>
                    <p style={paragraphStyle}>- Background Section - has two options to choose from. One is for using color, the other is for using images.</p>
                    <p style={paragraphStyle}>- Color Field - it's active only if the background image is inactive. if you have a color added and you click to Use image as background, the color field will be cleared and become inactive.</p>
                    <p style={paragraphStyle}>- Use image as background button - opens the section with image where you can choose from the already uploaded images or add a new one.</p>
                    <p style={paragraphStyle}>Тhe Save button saves all changes made to your background.</p>
                    <p>Тhe Cancel button cancels all changes made to your background.</p>
                    <p style={paragraphStyle}>2. Navigation Panel, contains the following elements</p>
                    <p style={paragraphStyle}>2.1. Move Icon</p>
                    <p style={paragraphStyle}>- Тhe Move Icon indicates that you can drag and drop the sections you've made as you want them to appear in your Email Template.</p>
                    <p style={paragraphStyle}>2.2. Section Title</p>
                    <p style={paragraphStyle}>- Тhe Section Title is different depending on what it is. In case the section is for added text, the title is always Text Box. If it is an Image Section the title is always the name of the image.</p>
                    <p style={paragraphStyle}>2.3. Delete Icon</p>
                    <p style={paragraphStyle}>- Clicking the delete icon deletes the section.</p>
                    <p style={paragraphStyle}>2.4. Text</p>
                    <p>- Тhe text you added to the Text section paragraph.</p>
                    <p style={paragraphStyle}>3. Preview</p>
                    <p style={paragraphStyle}>- In the preview you can see how your email template will look like with the relevant sections and styles you have added.</p>
                    <p><span style={{fontWeight: 'bold'}}>On the bottom-right corner of the screen there are the “Save” and “Delete” buttons. They are self explanatory. The Delete button is protected with a warning pop-up before calling the delete functionality.</span></p>
            </Col>
        )
    }

    render() {
        const { mainContainer, rowStyle, colStyle, backBtnStyle } = styles;
        const restaurantId = this.props.match.params.id;
        const marketingAutomationsId = this.props.selectedMarketingAutomation.trigger ? this.props.selectedMarketingAutomation.trigger.id : null;
        const textData = {
            header: i18n.t('screens:marketingAutomationScreen.deleteAutomation'),
            firstRow: i18n.t('screens:marketingAutomationScreen.deleteAutomationConfirmation'),
        };
        return (
            <React.Fragment>
                <Container fluid style={mainContainer}>
                    <Row sm={12} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 25px'}}>
                        <div>
                        <Button onClick={() => this.onBack()} color="primary" style={{ display: 'flex'}}>
                            <span style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="navigate_before" color="#fff" size={18} /></span>
                            <span style={backBtnStyle}>{i18n.t('common:buttons.back')}</span>
                        </Button>
                        </div>
                        <div>
                            <span>{i18n.t('screens:marketingAutomationScreen.help')}</span>
                            <span onClick={() => this.toggleHelperModal()} style={{cursor: 'pointer'}}>
                                <MaterialIcon icon="help" color="#0288d1" size={25} />
                            </span>
                        </div>
                    </Row>
                    <AvForm>
                        <Row style={rowStyle}>
                            <Col sm={4} style={colStyle}>
                                {this.renderNameDescription()}
                            </Col>
                            <Col sm={4} style={colStyle}>
                                {this.renderFilters()}
                            </Col>
                            <Col sm={4} style={colStyle}>
                                {this.renderDiscountType()}
                            </Col>
                        </Row>
                        <Row style={rowStyle}>
                            <Col sm={5} style={colStyle}>
                                {this.renderOrderTypes()}
                            </Col>
                            <Col sm={2} style={colStyle}>
                                {this.renderNotificationTypes()}
                            </Col>
                            <Col sm={5} style={colStyle}>
                                {this.renderNotificationFrequency()}
                            </Col>
                        </Row>
                        <Row style={rowStyle}>
                            <Col sm={3} style={colStyle}>
                                {this.renderCoolDownPeriod()}
                            </Col>
                            <Col sm={3} style={colStyle}>
                                {this.renderPromoCodeValidity()}
                            </Col>
                            <Col sm={6} style={colStyle}>
                                {this.renderNotificationTimes()}
                            </Col>
                        </Row>
                        <Row style={this.state.notificationType === 'EMAIL' ? rowStyle : { display: 'none' }}>
                            <Col sm={12} style={colStyle}>
                                {this.renderMailTemplates()}
                            </Col>
                        </Row>
                        <Row style={{ margin: 0 }}>
                            <Col sm={12} style={colStyle}>
                                {this.renderSaveDeleteButtons()}
                            </Col>
                        </Row>
                    </AvForm>
                </Container>
                <ConfirmationScreen
                    isOpen={this.state.deletePromotionConfirmationOpened}
                    onToggle={this.toggleConfirmationScreen}
                    onSave={this.deleteTrigger}
                    message={textData}
                />
                {this.renderFilterModal()}
                {this.renderCusotmerListModal()}
                {
                this.state.isHelperModalOpen &&
                    <CustomInsightsModal
                    header={i18n.t('screens:marketingAutomationScreen.helperInfo')}
                    isOpen={this.state.isHelperModalOpen}
                    onToggle={() => this.toggleHelperModal()}
                    children={this.renderHelperText()}
                >
                    </CustomInsightsModal>
                }
                {
                    this.state.isUsedPromoCodesModalOpen &&
                    <CustomInsightsModal
                        isOpen={this.state.isUsedPromoCodesModalOpen}
                        onToggle={this.toggleUsedPromoCodesModal}
                        header={i18n.t('screens:marketingAutomationScreen.usedPromoCodes')}
                        // className={'usedPromoCodesModal'}
                    >
                        <UsedPromoCodesModal restaurantId={restaurantId} customerId={this.state.customerId} maId={marketingAutomationsId} />
                    </CustomInsightsModal>
                    
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedMarketingAutomation: state.selectedMarketingAutomation,
        restaurant: state.restaurant,
        products: state.restaurantProducts,
        initialAudience: state.initialAudience,
        promotions: state.customerInsightPromotionNames,
        customers: state.marketingAutomations.customers,
        customerToAdd: state.marketingAutomations.customerToAdd
    }
};

export default connect(mapStateToProps,
    {
        loadRestaurantProducts,
        loadInitialAudienceCount,
        saveMarketingAutomation,
        editMarketingAutomation,
        setSelectedMarketingAutomation,
        deletePromotion,
        loadPromotionNames,
        loadCustomerAutomationSearch
    })
    (MarketingAutomationScreen);

const styles = {
    mainContainer: {
        backgroundColor: 'rgb(235,240,244)',
        paddingTop: '7px',
        marginTop: '10px'
    },
    rowStyle: {
        margin: '0',
        minHeight: '220px'
    },
    colStyle: {
        padding: '10px'
    },
    sectionDiv: {
        backgroundColor: 'white',
        height: '100%',
        paddingBottom: '10px'
    },
    inputWrapper: {
        paddingTop: '10px',
        paddingLeft: '10px',
        paddingRight: '10px',

    },
    inputFields: {
        border: '0',
        backgroundColor: '#f2f2f2',
        height: '30px',
        fontWeight: 'bold'
    },
    inputArea: {
        border: '0',
        backgroundColor: '#f2f2f2',
        height: '90px',
        fontWeight: 'bold'
    },
    contentSpacing: {
        padding: '20px',
        paddingTop: '10px'
    },
    contentSpacingNoBottom: {
        padding: '10px 20px',
    },
    flexSpaceBetween: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    line: {
        color: '#e6e6e6',
        margin: 0,
    },
    lineWithSpace: {
        color: '#e6e6e6',
        margin: 0,
        margin: '10px 0'
    },
    noteStyle: {
        color: '#959595',
        fontSize: '13px',
        fontWeight: 'bold',
        paddingBottom: '10px'
    },
    inputWithFixedWidth: {
        border: '0',
        backgroundColor: '#f2f2f2',
        height: '30px',
        fontWeight: 'bold',
        width: '60px',
        borderRadius: '5px',
        margin: '0 10px'
    },
    selectWithFixedWidth: {
        border: '0',
        backgroundColor: '#f2f2f2',
        height: '30px',
        fontWeight: 'bold',
        width: '90px',
        borderRadius: '5px',
        marginBottom: '-5px'
    },
    verticleCenter: {
        display: 'flex',
        alignItems: 'center'
    },
    bold: {
        fontWeight: 'bold'
    },
    searchResultContainer: {
        backgroundColor: '#ffffff',
        display: 'inline-block',
        width: 284,

        border: '1px solid #d2d2d2'
    },
    filterResultStyle: {
        fontSize: '24px',
        color: '#ef7ff2',
        fontWeight: 'bold',
        textAlign: 'right',
        padding: 0
    },
    linkStyle: {
        color: '#0288d1',
        textDecoration: 'underline',
        fontSize: '16px',
        padding: '5px 0 0 0',
        textAlign: 'right',
        fontWeight: 'bold',
        cursor: 'pointer'
    },
    singleFilter: {
        display: 'inline-block',
        backgroundColor: '#f2f2f2',
        borderRadius: '15px',
        marginBottom: '5px',
        marginRight: '5px',
        padding: '2px 10px 2px 10px',
        fontSize: '14px',
        fontWeight: 'bold'
    },
    emailTemplateBtnsTextStyle: {
        display: 'flex',
        alignSelf: 'center',
        padding: '0px 6px 3px'
    },
    emailTemplateBtnsStyle: {
        display: 'flex',
        border: 'none',
        color: '#fff',
        backgroundColor: '#0288d1',
        height: '30px',
        borderRadius: '15px',
        fontSize: '16px'
    },
    activeBtnStyle: {
        color: '#fff',
        backgroundColor: '#1b73d1',
        // borderColor: '#1b73d1'
    },
    emailTemplateItem: {
        backgroundColor: 'rgb(242, 242, 242)',
        minHeight: '400px',
        marginBottom: '10px'
    },
    emailTemplateInputStyle: {
        height: '30px',
        borderRadius: '5px'
    },
    navigationPanelItem: {
        cursor: 'grab',
        userSelect: 'none',
        margin: '20px auto',
        paddingTop: '10px',
        paddingBottom: '10px',
        minHeight: '50px', 
        backgroundColor: 'rgb(242, 242, 242)'
    },
    navigationPanelItemHeader: {
        display: 'flex',
        alignItems: 'center', 
        justifyContent: 'space-between'
    },
    paragraphStyle: {
        margin: '0px'
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '0 0 10px 0'
    },
    footerButtons: {
        margin: '0 15px 0 5px',
        borderRadius: '25px',
        minWidth: '100px',
        fontSize: '18px',
        padding: '0',
        height: '30px'
    },
    backBtnStyle: {
        display: 'flex',
        alignSelf: 'center',
        padding: '0px 6px 3px'
    },
};


// WEBPACK FOOTER //
// ./src/components/restaurants/marketingAutomations/MarketingAutomationScreen.js